import { useOutletContext } from "react-router-dom";
import { ContactDetails } from "@/features/person/components/ContactDetails";
import { Student } from "../../types";
import { useQuery } from "@apollo/client";
import { PERSON_DETAILS_QUERY } from "@/pages/people/[pgaId]/person/queries";
import { Person } from "@/types";
import { CardSkeleton } from "@/components/Skeleton";
import EmptyState from "@/components/EmptyState";

type PersonData = { person: Person };

export default function StudentContact() {
  const { student } = useOutletContext<{ student: Student }>();

  const { data, error } = useQuery<PersonData>(PERSON_DETAILS_QUERY, {
    variables: { pgaId: student.pgaId },
    fetchPolicy: "cache-first"
  });

  const { person } = data || {};

  if (error) {
    return <EmptyState title="Error" caption="An error occurred while loading contact information." iconName="error" />;
  }

  if (!person) {
    return (
      <div className="flex mt-12 gap-4">
        <CardSkeleton maxWidth={60} />
        <CardSkeleton maxWidth={60} />
      </div>
    );
  }

  return (
    <div>
      <ContactDetails person={person} />
    </div>
  );
}
